import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CHA003_Request,
  IAPI_CHA003_Response,
} from "../../../type/apiType";
import {
  IAPI_CHA004_Request,
  IAPI_CHA004_Response,
} from "../../../type/apiType";

/**
 * スレッド詳細一覧参照API
 * @return httpThreadDetailsList
 */
const httpAPI_CHA003 = async (
  param: IAPI_CHA003_Request
): Promise<IAPI_CHA003_Response> => {
  let res = await http.post(ApiUrl.API_CHA003, {
    ...param,
  });

  return res.data;
};

/**
 * スレッド詳細一覧更新API
 * @return httpAPI_CHA004
 */
const httpAPI_CHA004 = async (
  param: IAPI_CHA004_Request
): Promise<IAPI_CHA004_Response> => {
  let res = await http.post(ApiUrl.API_CHA004, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CHA003, httpAPI_CHA004 };
